// Reference/lookup data — effectively immutable, cache forever.
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../../api/client";

export const useSportFieldSports = (options = {}) =>
  useQuery({
    queryKey: ["sport-fields", "sports"],
    queryFn: () =>
      apiFetch("/sport-fields", { query: { is_active: "true", pageSize: 100, sort: "name", order: "asc" } }),
    select: (data) => data.items || [],
    staleTime: Infinity,
    ...options,
  });

export const useSportTrainingFields = (sportId, options = {}) =>
  useQuery({
    queryKey: ["sport-fields", "training-fields", sportId ?? "all"],
    queryFn: () =>
      apiFetch("/sport-training-fields", {
        query: {
          is_active: "true",
          pageSize: 100,
          sort: "sort_order",
          order: "asc",
          ...(sportId ? { sport_id: sportId } : {}),
        },
      }),
    select: (data) => data.items || [],
    staleTime: Infinity,
    ...options,
  });
